var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('vm-header'),_vm._v(" "),_c('v-Massage1'),_vm._v(" "),_c('saixuantop2'),_vm._v(" "),_c('v-crumbs'),_vm._v(" "),_c('div',{staticClass:"btn-last"},[_c('button',{attrs:{"type":"button"},on:{"click":_vm.tijiao}},[_vm._v("提交")])]),_vm._v(" "),_c('item7')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afccff1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/mine/g_zhinengxuanke.vue
// module id = null
// module chunks = 